import SingleActionButton from './single_action_button.jsx';
import ActionButton from './action_button.jsx';

import DropdownButton from '../../../realize_overrides/components/dropdown/dropdown_button.jsx';

export default class GroupActionButton extends SingleActionButton {

	render() {
		return (
			<DropdownButton
				{...this.props}
				name={this.getActionButtonName()}
				itemComponent={ActionButton} />
		);
	}
}
